import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
  Stack,
  MenuItem
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

export default function DemoWidgetPage() {
  const navigate = useNavigate();
  const submit = async e => {
    navigate(`/sitopubblico/demorequest`);
  };

  return (
    <Box p={3}>
      <Typography variant="h6">Richiedi una demo</Typography>
      <form onSubmit={submit}>
        {/* campi */}
        <Button type="submit" fullWidth variant="contained">
          Invia
        </Button>
      </form>
    </Box>
  );
}